/* Map Shopify header labels to live sublmnl.ca URLs during migration */
(function () {
  var map = {
    'Create Audio': 'https://sublmnl.ca/create',
    FAQ: 'https://sublmnl.ca/faq',
    Contact: 'https://sublmnl.ca/contact',
    'Contact Us': 'https://sublmnl.ca/contact',
  };

  function apply() {
    document.querySelectorAll('#header-component a, .header-drawer a, .menu-drawer a').forEach(function (a) {
      var label = (a.textContent || '').trim();
      if (map[label]) a.setAttribute('href', map[label]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
